import React from 'react';
import { NSGPTCard } from 'bricks';
import Map from 'components/Map/Map';
import { DEFAULT_NYC_COORDINATES } from 'constants/deals';
import { LocationData, GPTCheckboxItem } from '../../../types';
import { useGPTCheckboxManager } from '../../../hooks/useGPTCheckboxManager';
import { useInvestmentMemoContext } from '../../../InvestmentMemoContext';

interface LocationFormProps {
    data: LocationData;
    onChange: (data: Partial<LocationData>) => void;
    isLoading?: boolean;
    aiSuggestions?: GPTCheckboxItem[];
}

const LocationForm = ({
    data, onChange, isLoading = false, aiSuggestions = [],
}: LocationFormProps) => {
    const { shouldShowError, getFieldError } = useInvestmentMemoContext();
    const {
        allItems,
        handleCheckboxCheck,
        handleAddCustomItem,
        handleDeleteCheckbox,
        handleEditCheckbox,
    } = useGPTCheckboxManager({
        currentItems: data.drivers || [],
        aiSuggestions,
        onChange: items => onChange({ drivers: items }),
    });

    return (
        <div className="px-3 pb-3">
            <div className="mb-3 mt-3 w-100">
                <p>Aerial Map</p>
                <Map
                    lat={data.coordinates?.lat ?? DEFAULT_NYC_COORDINATES.lat}
                    lng={data.coordinates?.lng ?? DEFAULT_NYC_COORDINATES.lng}
                    height="273px"
                    zoom={10}
                />
            </div>
            <NSGPTCard
                label="Select proximity drivers"
                checkboxContent={allItems}
                onCheckboxCheck={handleCheckboxCheck}
                onDeleteCheckbox={handleDeleteCheckbox}
                onEditCheckbox={handleEditCheckbox}
                shouldAddCustomSection
                customSectionButtonLabel="Add custom driver"
                customNamePlaceholder="Driver name"
                customDescriptionPlaceholder="Driver description"
                onCustomItemAdd={handleAddCustomItem}
                isLoading={isLoading}
                loadingMessage="Generating proximity drivers..."
            />
            {!isLoading && shouldShowError('location.drivers') && (
                <p className="text-danger small mt-1 mb-0">
                    {getFieldError('location.drivers')}
                </p>
            )}
        </div>
    );
};
export default LocationForm;
